import axios from "axios";
import { baseUrl, buildQuery } from "../config/api-config";

const base = `${baseUrl}`;

export function getCaseNegotiations(token, caseId, query) {
    const q = buildQuery(query);
    return axios.get(`${baseUrl}/case/${caseId}/negotiations${q}`, {
        headers: {
            authorization: token
        }
    })
}

export function addNewNegotiation (token, caseId, data) {
    return axios.post(`${baseUrl}/case/${caseId}/negotiation`, data, {
        headers: {
            authorization: token
        }
    })
}

export function getNegotiationDetails (token, caseId, negId) {
    return axios.get(`${baseUrl}/case/${caseId}/negotiation-details/${negId}`, {
        headers: {
            authorization: token
        }
    })
}

export function addNegotiationDetails (token, caseId, data) {
    return axios.post(`${baseUrl}/case/${caseId}/negotiation-detail`, data, {
        headers: {
            authorization: token
        }
    })
}

export function confirmNegotiation (token, caseId, negId) {
    return axios.patch(`${baseUrl}/case/${caseId}/negotiation/${negId}/confirm`, {}, {
        headers: {
            authorization: token
        }
    })
}

export function getNegotiationInsight(token, caseId, negId) {
    return axios.post(`${baseUrl}/ai/case/${caseId}/negotiation/${negId}/insight`, {}, {
        headers: {
            authorization: token
        }
    });
}

export function withdrawNegotiation(token, caseId, negId) {
    return axios.patch(`${baseUrl}/case/${caseId}/negotiation/${negId}/withdraw`, {}, {
        headers: {
            authorization: token
        }
    });
}

export function submitBlindBid(token, caseId, negId, data) {
    return axios.post(`${baseUrl}/case/${caseId}/negotiation/${negId}/blind-bid`, data, {
        headers: {
            authorization: token
        }
    });
}

export function addNegotiationProposal(token, caseId, negId, data) {
    return axios.post(`${baseUrl}/case/${caseId}/negotiation/${negId}/proposal`, data, {
        headers: {
            authorization: token
        }
    });
}

export function respondToProposal(token, caseId, negId, proposalId, response) {
    return axios.patch(`${baseUrl}/case/${caseId}/negotiation/${negId}/proposal/${proposalId}/respond`, { response }, {
        headers: {
            authorization: token
        }
    });
}

export function getNegotiationAgreement(token, caseId, negId) {
    return axios.get(`${baseUrl}/case/${caseId}/negotiation/${negId}/agreement`, {
        headers: {
            authorization: token
        }
    });
}

export function getNegotiationTerms(token, caseId) {
    return axios.get(`${baseUrl}/case/${caseId}/negotiation-terms`, {
        headers: {
            authorization: token
        }
    });
}

export function getNegotiationInsightLog(token, caseId, negId) {
    return axios.get(`${baseUrl}/ai/case/${caseId}/negotiation/${negId}/insight-log`, {
        headers: {
            authorization: token
        }
    });
}
